import { Observable } from "rxjs";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../environments/environment";

import { AppliedEvaluation } from "../model/avalicorp/AppliedEvaluationModel";

import { AppliedEvaluationStatus } from "./applied-evaluation-status-constant";

import _ from "lodash";

@Injectable()
export class EvaluationService {
  constructor(private http: HttpClient) {}

  public listByUserId(userId: number): Observable<AppliedEvaluation[]> {
    return this.http.get<AppliedEvaluation[]>(
      environment.apiHost +
        "/avalicorp/administration/apply/evaluations/user/" +
        userId
    );
  }

  public save(applyEvaluation) {
    var copy = _.assign({}, applyEvaluation);
    this.convertUsersProcess(true)(copy);

    let headers = new HttpHeaders({
      Accept: "application/json, text/plain, */*",
      "Content-Type": "application/json;charset=utf-8",
    });
    return this.http
      .post(
        environment.apiHost +
          "/avalicorp/administration/apply/evaluations/save",
        copy,
        { headers: headers, responseType: "text" }
      )
      .map((response) => JSON.parse(response));
  }

  public getBySupervisor(appliedEvaluations: any): any {
    return _.filter(
      appliedEvaluations,
      (item) =>
        this.isSupervisor(item.type) &&
        item.status == AppliedEvaluationStatus.AGUARDANDO_APROVACAO
    ).map((item) => {
      return this.getMyEvaluation(item);
    });
  }

  public getByEvaluator(appliedEvaluations: any): any {
    return _.filter(
      appliedEvaluations,
      (item) =>
        this.isEvaluator(item.type) &&
        item.usersProcess.evaluator.status !=
          AppliedEvaluationStatus.CONCLUIDO &&
        !(
          item.hasSelfEvaluation &&
          item.usersProcess.evaluated.status !=
            AppliedEvaluationStatus.CONCLUIDO
        )
    ).map((item) => {
      return this.getMyEvaluation(item);
    });
  }

  public getByEvaluated(appliedEvaluations: any, userId): any {
    return _.filter(
      appliedEvaluations,
      (item) =>
        this.isEvaluated(item.type) &&
        ((item.hasSelfEvaluation &&
          item.usersProcess.evaluated.status !=
            AppliedEvaluationStatus.CONCLUIDO) ||
          item.status == AppliedEvaluationStatus.EM_VERIFICACAO ||
          (item.status == AppliedEvaluationStatus.CONCLUIDO &&
            item.evaluatedUserId == userId))
    ).map((item) => {
      item.interaction = this.getEvaluatedInteraction(item.status, item);
      item.isDisabled = item.disabledRevisionEvaluated;

      if (item.dateIssued)
        item.disabledIndicator =
          new Date().getTime() < new Date(item.dateIssued).getTime();

      // após o término da avaliação, é desabilitada a visualização dos resultados, de acordo com a data de emissão.
      if (
        item.status == AppliedEvaluationStatus.CONCLUIDO &&
        item.disabledIndicator
      )
        item.isDisabled = true;

      // após o término da avaliação, é liberada a visualização ao avaliado, a partir da data de emissão dos resultados
      if (
        item.status == AppliedEvaluationStatus.CONCLUIDO &&
        !item.disabledIndicator &&
        item.disabledRevisionEvaluated
      )
        item.isDisabled = false;

      return item;
    });
  }

  public isEvaluator(type: string): boolean {
    return type == "evaluator";
  }

  public isEvaluated(type: string): boolean {
    return type == "evaluated";
  }

  public isSupervisor(type: string): boolean {
    return type == "supervisor";
  }

  private getMyEvaluation(myEvaluation: any) {
    myEvaluation.interaction = this.getInteraction(
      myEvaluation.type,
      myEvaluation.status
    );
    myEvaluation.sendToApprove =
      this.isEvaluator(myEvaluation.type) &&
      myEvaluation.usersProcess["evaluated"].concludeDate;
    return myEvaluation;
  }

  private getInteraction(type: string, status: number): AppliedEvaluation {
    var interactionByType = {
      supervisor: { text: "Supervisionar", disabled: true, show: true },
      evaluator: this.getEvaluatorInteraction(status),
    };
    return interactionByType[type];
  }

  private getEvaluatorInteraction(status: number): any {
    switch (status) {
      case AppliedEvaluationStatus.NAO_INICIADO:
      case AppliedEvaluationStatus.EM_ANDAMENTO:
      case AppliedEvaluationStatus.ATRASADO:
      case AppliedEvaluationStatus.REPROVADO:
      case AppliedEvaluationStatus.AGUARDANDO_CONCLUSAO:
        return { text: "Realizar", disabled: false, show: true };
      default:
        return { text: "", disabled: true, show: false };
    }
  }

  public getEvaluatedInteraction(
    status: number,
    applied: AppliedEvaluation
  ): Object {
    if (
      status == AppliedEvaluationStatus.NAO_INICIADO ||
      status == AppliedEvaluationStatus.EM_ANDAMENTO
    )
      return { text: "Realizar", disabled: false, show: true };

    if (
      status == AppliedEvaluationStatus.EM_VERIFICACAO &&
      !applied.usersProcess.evaluated.concludeDate
    )
      return { text: "Verificar", disabled: false, show: true };

    if (status == AppliedEvaluationStatus.CONCLUIDO)
      return { text: "Visualisar", disabled: true, show: true };

    return { text: "", disabled: true, show: false };
  }

  public convertUsersProcess(toJson: boolean) {
    return (item: AppliedEvaluation) => {
      var convertMethod = toJson ? "stringify" : "parse";
      if (item.usersProcess)
        item.usersProcess = JSON[convertMethod](item.usersProcess);
    };
  }
}



// WEBPACK FOOTER //
// ./src/services/evaluation-service.ts